import { formatCurrency } from './format-currency';

export const getCurrency = () => {
  return formatCurrency(0, 0).replaceAll('0', '');
};
